import React from "react";
import styles from "../styles/Modal.module.css";
import confirmed from "../assets/images/successfully-confirmed.png";

export default function Modal({ controller }) {
  return (
    <div className={styles.modal}>
      <div className={styles.container}>
        <span onClick={() => controller(false)} className={styles.close}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </span>
        <img src={confirmed} alt="confirmed" />
        <h2>Your order is complete!</h2>
        <h4>Thank You</h4>
        <p>On my way to your table</p>
      </div>
    </div>
  );
}
